import { ButtonBase, ButtonBaseProps, styled } from '@mui/material';
import { PoolInstance, isInstance } from '@synergy/config';
import { PoolTypography } from '@synergy/components-next';
import { ReactElement } from 'react';
import { shouldForwardPropExclude } from '@synergy/utils';

import polygon from './category-bar-button-polygon.svg';

const BoxButton = styled(ButtonBase, { shouldForwardProp: shouldForwardPropExclude('poolInstance') })(({ theme }) => ({
    // min/max width same as pool-card
    minWidth: 287,
    maxWidth: 430,
    height: theme.spacing(7),
    padding: theme.spacing(0, 2),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'normal',
    border: `1px solid ${theme.palette.grey['400']}`,
    borderRadius: 4,
    backgroundColor: theme.palette.common.white,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right',
    backgroundSize: 'contain',
    transition: theme.transitions.create('background-color', { duration: theme.transitions.duration.shortest }),
    ...(!isInstance(PoolInstance.CH) && { backgroundImage: `url(${polygon})` }),

    '&:hover': {
        backgroundColor: theme.palette.grey['100'],
    },
}));

export interface CategoryBarButtonProps extends ButtonBaseProps {
    count?: number;
}

export const CategoryBarButton = (props: CategoryBarButtonProps): ReactElement => {
    const { count, children, ...buttonBaseProps } = props;
    return (
        <BoxButton {...buttonBaseProps}>
            <PoolTypography
                variant="body1"
                component={'div'}
                sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}
            >
                {children}
            </PoolTypography>
            &nbsp;
            {count !== undefined && <PoolTypography variant="caption">({count})</PoolTypography>}
        </BoxButton>
    );
};
